export default __webpack_public_path__ + "54b75c50fcd9a026cda1604040c6ce14.gif";